import { useEffect, useState } from "react";
import { toast } from "sonner";
import { HeartHandshake, Loader2, Save } from "lucide-react";
import { api, apiError } from "@/lib/apiClient";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";

// Combinazioni del Volontariato proponibili dai Partner (uguale per tutti); le altre restano all'Agenzia.
export const MrvCombosCard = () => {
  const [all, setAll] = useState([]);
  const [codes, setCodes] = useState([]);
  const [saving, setSaving] = useState(false);
  useEffect(() => { api.get("/admin/settings/mrv-combinazioni").then(({ data }) => { setAll(data.all); setCodes(data.codes); }).catch(() => {}); }, []);
  const toggle = (c) => setCodes((cs) => (cs.includes(c) ? cs.filter((x) => x !== c) : [...cs, c]));
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/admin/settings/mrv-combinazioni", { codes }); setCodes(data.codes); toast.success("Combinazioni Partner salvate"); }
    catch (e) { toast.error(apiError(e)); } finally { setSaving(false); }
  };
  return (
    <Card className="max-w-3xl rounded-xl border-border/60 p-6" data-testid="settings-mrv-combos-card">
      <h2 className="flex items-center gap-2 font-heading text-lg font-semibold text-forest"><HeartHandshake className="h-5 w-5" />Volontariato: combinazioni per i Partner</h2>
      <p className="mt-1 text-sm text-muted-foreground">Spunta le combinazioni che i Partner possono proporre. Quelle non spuntate restano riservate all'Agenzia.</p>
      <div className="mt-4 grid grid-cols-3 gap-2">
        {all.map((c) => (
          <label key={c} className={`flex cursor-pointer items-center gap-2 rounded-lg border px-3 py-2 text-sm transition-colors ${codes.includes(c) ? "border-forest bg-sage text-forest" : "border-border text-muted-foreground"}`}>
            <input type="checkbox" checked={codes.includes(c)} onChange={() => toggle(c)} data-testid={`mrv-combo-${c}`} />Combinazione {c}
          </label>
        ))}
      </div>
      <Button onClick={save} disabled={saving || !codes.length} data-testid="mrv-combos-save" className="mt-4 gap-2 rounded-lg bg-terracotta hover:bg-terracotta-hover">
        {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />} Salva combinazioni
      </Button>
    </Card>
  );
};
